import { storeOverviewColumns, storeOverviewCopy, storeTargetRemainder } from "./storeOverviewPresentation";
import { desktopColumnLabel } from "./desktopInformation";
import { standardCopy } from "./tableStandard";
const dailyRequiredNumber = new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 0 });

export type ExistingAdviserColumn = { key: string; label: string };
export type AdviserOverviewColumn = ExistingAdviserColumn & { width: number; group: number };

const approvedOrder = ["store", "name", "target", "sales", "achievement", "remaining", "upt", "basket", "unit", "receipts", "units", "share"];
const widths: Record<string, number> = {
  store: 185, name: 265, target: 130, sales: 130, achievement: 120, remaining: 140,
  upt: 60, basket: 110, unit: 105, receipts: 80, units: 70, share: 90,
};

// Layout and labels only. Retain exactly the existing adviser fields supplied
// by the caller; a styling change must not invent CR, visitors or LY metrics.
export function adviserOverviewColumns(available: ExistingAdviserColumn[], language: string): AdviserOverviewColumn[] {
  const c = storeOverviewCopy(language);
  const shareLabel = storeOverviewColumns(language).find(column => column.key === "share")!.label;
  const labels: Record<string, string> = {
    store: c[0], target: c[1], sales: c[2], achievement: c[3], remaining: c[4],
    upt: "UPT", basket: c[13], unit: c[14], receipts: c[11], units: c[12], share: shareLabel,
  };
  const originals = new Map(available.map(column => [column.key, column]));
  const keys = [...approvedOrder.filter(key => originals.has(key)), ...available.map(column => column.key).filter(key => !approvedOrder.includes(key))];
  return keys.map(key => ({
    ...originals.get(key)!,
    label: key === "share" ? standardCopy(language).share : desktopColumnLabel(key, labels[key] ?? originals.get(key)!.label, language),
    width: widths[key] ?? 120,
    group: key === "store" || key === "name" ? 0 : ["target", "sales", "achievement", "remaining"].includes(key) ? 1 : key === "upt" ? 2 : 3,
  }));
}

// The owner-approved screen addition reuses the established store/insight
// definition and selected report end. Existing API targets and exports remain
// untouched, including the full-month-off and month-end fallback behavior.
export function formatAdviserDailyRequired(target: number | null, sales: number, asOfDate?: string, fullMonthTarget = true): string {
  const daily = storeTargetRemainder(target, sales, asOfDate, fullMonthTarget).daily;
  return daily == null || !Number.isFinite(daily)
    ? "—"
    : dailyRequiredNumber.format(Math.round(daily));
}
